import React from "react";
import Auth2faNew from "components/App/2fa_new";
import Auth2fa from "components/App/2fa";
import { useRouter } from "next/router";
import sessionStorage from "utils/sessionStorage";
import { getAbsoluteUrl } from "../../../../utils/method";

export default function StepTwo({ emailphoneNum }) {
  const router = useRouter();

  /** 无 2fa 数据时（如刷新或数据结构不匹配）回到 step=1，避免误跳到登录页 */
  const noDataCallback = () => {
    const query = { ...router.query, step: 1 };
    if (typeof location !== "undefined")
      location.replace(
        getAbsoluteUrl({
          pathname: "/reset-password",
          locale: router.locale,
          query,
        })
      );
    else router.replace({ pathname: "/accounts/reset-password", query });
  };

  const on2FaSuccess = (res) => {
    const { faResultId = "" } = res;
    sessionStorage.set("faResultId", faResultId);
    // sessionStorage.set("faId", res.faId);

    const query = { ...router.query, step: 3 };
    if (typeof location !== "undefined")
      location.href = getAbsoluteUrl({
        pathname: "/reset-password",
        locale: router.locale,
        query,
      });
    else
      router.push({
        path: "./reset-password",
        query,
      });
  };

  return (
    <div className="stepForm">
      {/*<Auth2faNew onSuccess={on2FaSuccess} />*/}
      <Auth2fa
        codeType={"102"}
        onSuccess={on2FaSuccess}
        noDataCallback={noDataCallback}
        skipGeetest
      />
    </div>
  );
}
